import { editMixin } from '@/mixins/edit';

/**
 * Mixin do zarządzania etapami kreatora
 *
 * @export
 * @param {string} moduleName - nazwa modułu
 * @returns
 */
export function wizardStepMixin(moduleName) {
  return {
    mixins: [editMixin(moduleName)],

    methods: {
      // @vuese
      // Przenosi do następnego kroku
      nextStep() {
        if (this.id) {
          this.$emit('nextStep', this.id);
        }
      },
      // @vuese
      // Funkcja wywoływana wykonaniu zapisu
      afterSave(id) {
        this.$emit('nextStep', id);
      },
      // @vuese
      // Przenosi do poprzedniego kroku
      previousStep() {
        if (this.id) {
          this.$emit('previousStep', this.id);
        }
      }
    }
  };
}
